import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0116c3b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "k-game-content-area" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pause" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]

import { ref } from 'vue';
import { useMotion, MotionVariants, useMotions } from '@vueuse/motion';
import GameTimer from 'src/components/game-timer.vue';
import { useModule } from 'src/modules/modules';
import PointerFx from 'src/components/pointer-fx.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'game-content-area',
  props: {
    hideTray: Boolean,
    infiniteTime: Boolean,
    noPointerFx: Boolean,
    highContrast: Boolean
},
  emits: ['down', 'skip'],
  setup(__props, { expose, emit }) {

const props = __props

_useCssVars(_ctx => ({
  "26fa1b54": (_unref(cardBg))
}))

const { game, theme } = useModule();



const handlePointerDown = (e: PointerEvent) => {
    emit('down', e);
}

const cardBg = props.highContrast ? '#0000006c' : theme.theme.cardBg;

const skipped = ref(false);
const handleSkip = () => {
    if (!skipped.value){
        skipped.value = true;
        game.useSkip();
        emit('skip');
        return;
    }
}

const instruction = ref();
const instructionMotion = useMotion(instruction, {
    initial: {
        opacity: 0,
        y: -200
    },
    enter: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 350,
            ease: 'easeOut'
        }
    },
    leave: {
        opacity: 0,
        y: -200,
        transition: {
            duration: 350,
            ease: 'easeIn'
        },
    }
})


const tray = ref();
const trayMotion = useMotion(tray, {
    initial: {
        opacity: 0,
        y: 200
    },
    enter: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 350,
            ease: 'easeOut'
        }
    },
    leave: {
        opacity: 0,
        y: 200,
        transition: {
            duration: 350,
            ease: 'easeIn'
        },
    }
})



expose({
    leave: () => {
        return Promise.all([
            instructionMotion.apply('leave'),
            trayMotion.apply('leave')
        ])
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(game).matchState.gameOver && !__props.noPointerFx)
      ? (_openBlock(), _createBlock(PointerFx, {
          key: 0,
          "color-start": "#ffffff",
          "color-end": "#ffffff"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "instruction",
      ref: instruction,
      class: "k-game-content-area__instruction"
    }, [
      _renderSlot(_ctx.$slots, "instruction")
    ], 512),
    _createElementVNode("div", {
      class: "k-game-content-area__content",
      onPointerdown: handlePointerDown,
      style: _normalizeStyle({ padding: _unref(game).useReducedPadding ? '5px' : '7%' })
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 36),
    (!__props.hideTray)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "tray",
          ref: tray,
          class: "k-game-content-area__tray"
        }, [
          _createElementVNode("button", {
            class: "k-pause-btn mr-2",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(game).togglePaused && _unref(game).togglePaused(...args)), ["stop","prevent"])),
            style: {"margin-right":"10px","width":"50px"}
          }, _hoisted_3),
          _createVNode(GameTimer, {
            infinite: __props.infiniteTime,
            "high-contrast": __props.highContrast
          }, null, 8, ["infinite", "high-contrast"]),
          (_unref(game).matchState.skips > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "k-skip-btn mr-2",
                onClick: _withModifiers(handleSkip, ["stop","prevent"])
              }, " Skip ", 8, _hoisted_4))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true)
  ]))
}
}

})